import script from "./batchOrderSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./batchOrderSupplier.vue?vue&type=script&setup=true&lang=js"

import "./batchOrderSupplier.vue?vue&type=style&index=0&id=1779d84e&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1779d84e"]])

export default __exports__